import * as React from "react"
import { Box, TableCell } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDoubleDown, faChevronDoubleUp } from "@fortawesome/pro-solid-svg-icons";

interface ExtendedTableCellProps {
    sorted?: boolean;
    sortDescending?: boolean;
    handleClick?: any;
    children?:  React.ReactNode;
    justify?: 'start' | 'center' | 'end';
}

const ExtendedTableCell: React.FunctionComponent<ExtendedTableCellProps> = ({ sorted, sortDescending, handleClick, children, justify }) => {

    const handleCellClick = () => {
        if(handleClick){
            handleClick();
        }
    }

    return (
        <TableCell
            onClick={handleCellClick}
            sx={{
                '&:hover': {
                    cursor: handleClick ? 'pointer' : 'inherit'
                }
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: justify ?? 'start'
                }}
            >
                {
                    sorted &&
                    <Box
                        sx={{
                            mr: 1
                        }}
                    >
                        {
                            sortDescending ?
                                <FontAwesomeIcon fixedWidth icon={faChevronDoubleDown} />
                                : <FontAwesomeIcon fixedWidth icon={faChevronDoubleUp} />
                        }
                    </Box>
                }
                <Box
                    sx={{
                        width: 'fit-content'
                    }}
                >
                    {children}
                </Box>
            </Box>
        </TableCell>
    )
}

export default ExtendedTableCell;